const parseData = (value, index) =>
  index > 1 && index < 7 ? parseInt(value) : value;

const DateAndTimeRE =
  /([A-Za-z])+\s(\d+)-(\d+)-(\d+)\s(\d+):(\d+):(\d+)/;

const localTimeFacts = (input) => {
  const match = input.match(DateAndTimeRE);
  if (match === null) return {};
  const [_all, _dow, year, month, day, hour, minute] = match.map(parseData);
  return { year, month, day, hour, minute, localTime: input };
};

const timezoneFacts = (input) => {
  const [timezone] = input.trim().split(" ");
  return { timezone };
};

const factsOfTuple = ([field, value]) =>
  field === "Local time"
    ? localTimeFacts(value)
    : field === "Timezone"
    ? timezoneFacts(value)
    : {};

const fieldAndValue = (line) => line.split(/:\s+/).map((value) => value.trim());

const intoSettings = (settings, line) => ({
  ...settings,
  ...factsOfTuple(fieldAndValue(line)),
});

export const parseTimeSettings = (input) =>
  input.trim().split("\n").reduce(intoSettings, {});

const valueAndLabel = ([_, country, timezone, alt]) => ({
  value: timezone,
  label: `${country} ${timezone}`,
  ...(alt.length > 0 ? { alt } : {}),
});

const TimeZoneRE = /([A-Z]+)\s+([^ ]*)\s*(.*)$/;

const intoValueAndLabel = (line) => valueAndLabel(line.match(TimeZoneRE));

export const parseTimezones = (input) => {
  const [_head, ...rows] = input.trim().split("\n");
  return rows.map(intoValueAndLabel);
};
